import { FC } from 'react';
import styles from './PageHeader.module.scss';

export interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  primaryAction?: {
    label: string;
    href?: string;
    onClick?: (e?: any) => void;
  };
  secondaryAction?: {
    label: string;
    href?: string;
    onClick?: (e?: any) => void;
  };
}

export const PageHeader: FC<PageHeaderProps> = ({
  eyebrow,
  title,
  subtitle,
  primaryAction,
  secondaryAction,
}) => {
  return (
    <div className={styles.header}>
      <div className={styles.textGroup}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>

      {(primaryAction || secondaryAction) && (
        <div className={styles.actions}>
          {secondaryAction && (
            <a
              href={secondaryAction.href || '#print'}
              className={styles.secondaryButton}
              onClick={secondaryAction.onClick}
            >
              {secondaryAction.label}
            </a>
          )}
          {primaryAction && (
            <a
              href={primaryAction.href || '#document-library'}
              className={styles.primaryButton}
              onClick={primaryAction.onClick}
            >
              {primaryAction.label}
            </a>
          )}
        </div>
      )}
    </div>
  );
};
